import * as React from "react";
const SvgFavoriteFill24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 23,
        fill: "black",
        viewBox: "0 0 24 23"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M15.695 7.914 12 .84 8.305 7.914.435 9.243l5.586 5.7-1.168 7.895L12 19.287l7.148 3.55-1.169-7.894 5.586-5.7-7.87-1.329Z",
      clipRule: "evenodd"
    })
  );
export default SvgFavoriteFill24Px;
